export const FLOATING_PLUGIN_TOOLBAR = 'floating-plugin-toolbar';
